import axios from "axios";
import { BASE_END_POINT } from "../../urls";
import { message } from "antd";

// Function to get ads data
export const getDataApi = async (id, token, isRTL) => {
    try {
        const response = await axios.get(`${BASE_END_POINT}/ads/${id}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'Accept-Language': isRTL ? 'ar' : 'en',
            }
        });
        return response.data;
    } catch (error) {
        console.log(error.response)
    }

};
// Function to get ad marketing info
export const getAdMarketingApi = async (page, id, token, isRTL) => {
    try {
        const response = await axios.get(`${BASE_END_POINT}marketerAds?advertisement=${id}&page=${page}&limit=${10}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'Accept-Language': isRTL ? 'ar' : 'en',
            }
        });
        return response.data;
    } catch (error) {
        console.log(error.response)
    }

};
// Function to get ad marketing info
export const getSuggestedClientsApi = async (page, id, token, isRTL) => {
    try {
        const response = await axios.get(`${BASE_END_POINT}requests/${id}/getSuggestedClients?page=${page}&limit=${10}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'Accept-Language': isRTL ? 'ar' : 'en',
            }
        });
        return response.data;
    } catch (error) {
        console.log(error.response)
    }
};
// Function to get projects
export const getProjectsApi = async () => {
    try {
        const response = await axios.get(`${BASE_END_POINT}projects/withoutPagenation/get`);
        return response.data;
    } catch (error) {
        console.log(error.response)
    }
};

// Function to search for related employee
export const searchForRelatedEmployeeApi = async (clientPhone, project, token, isRTL) => {
    try {
        const response = await axios.post(`${BASE_END_POINT}interests/searchForReleatedEmployee/get`, {
            clientPhone: clientPhone,
            project: project
        }, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'Accept-Language': isRTL ? 'ar' : 'en',
            },
        });
        return response.data;
    } catch (error) {
        console.log(error.response)
    }

};
// Function to delete an ad
export const deleteApi = async (id, token, isRTL, allStrings) => {
    let l = message.loading('Wait..', 2.5);
    try {
        const response = await axios.delete(`${BASE_END_POINT}ads/${id}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'Accept-Language': isRTL ? 'ar' : 'en',
            },
        });
        l.then(() => message.success(allStrings.done, 2.5));
        return response.data;
    } catch (error) {
        console.log(error.response)
        l.then(() => message.error(allStrings.error, 2.5))
    }

};

// Function to send to Redf
export const sendToRedfApi = async (id, token, isRTL, allStrings) => {
    let l = message.loading('Wait..', 2.5);
    try {
        const response = await axios.post(`${BASE_END_POINT}ads/${id}/addRedfAdvertisement`, {}, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'Accept-Language': isRTL ? 'ar' : 'en',
            }
        });
        l.then(() => message.success(allStrings.done, 2.5));
        return response.data;
    } catch (error) {
        console.log(error.response)
        l.then(() => message.error(allStrings.error, 2.5))
    }

};

// Function to market an advertisement
export const marketAdvertisementApi = async (id, inMarket, commissionCost, token, allStrings) => {
    let l = message.loading('Wait..', 2.5);
    try {
        const uri = inMarket
            ? `${BASE_END_POINT}ads/${id}/addInMarket`
            : `${BASE_END_POINT}ads/${id}/removeFromMarket`;

        const response = await axios.put(uri, { commissionCost: commissionCost }, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        });
        l.then(() => message.success(allStrings.done, 2.5));
        return response.data;
    } catch (error) {
        console.log(error.response)
        l.then(() => message.error(allStrings.error, 2.5))
    }

};

// Function to add SEO description

export const addSeoDescApi = async (id, seoData, token, isRTL, allStrings) => {
    let l = message.loading('Wait..', 2.5);
    try {
        const response = await axios.put(`${BASE_END_POINT}ads/${id}/addContentDesc`, JSON.stringify(seoData), {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'Accept-Language': isRTL ? 'ar' : 'en'
            },
        });
        l.then(() => message.success(allStrings.done, 2.5));
        return response.data;
    } catch (error) {
        console.log(error.response)
        l.then(() => message.error(allStrings.error, 2.5))
    }

};

// Function to make a deal
export const makeDealApi = async (data, token, isRTL, allStrings) => {
    let l = message.loading('Wait..', 2.5);
    try {
        const response = axios.post(`${BASE_END_POINT}deals/`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${token}`,
                'Accept-Language': isRTL ? 'ar' : 'en'
            },
        });
        l.then(() => message.success(allStrings.done, 2.5));
        return response.data;
    } catch (error) {
        console.log(error.response)
        l.then(() => message.error(allStrings.error, 2.5))
    }

};

// Function to update Rega data
export const updateRegaDataApi = (id, data, token, isRTL, allStrings) => {
    let l = message.loading('Wait..', 2.5);
    try {
        const response = axios.put(`${BASE_END_POINT}ads/${id}/updateRegaData`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'Accept-Language': isRTL ? 'ar' : 'en'
            },
        });
        l.then(() => message.success(allStrings.done, 2.5));
        return response.data;
    } catch (error) {
        console.log(error.response)
        l.then(() => message.error(allStrings.error, 2.5))
    }

};

// Function to get users without pagination
export const getUserWithoutPagenationApi = async (token, isRTL) => {
    try {
        const response = await axios.get(`${BASE_END_POINT}quickSearch/get?type=SUB-ADMIN`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'Accept-Language': isRTL ? 'ar' : 'en',
            },
        });
        return response.data;
    } catch (error) {
        console.log(error.response)
    }
};

// Function to update status
export const updateStatusApi = async (id, data, token, isRTL, allStrings) => {
    let l = message.loading('Wait..', 2.5);
    try {
        const response = await axios.put(`${BASE_END_POINT}ads/${id}/updateStatus`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${token}`,
                'Accept-Language': isRTL ? 'ar' : 'en'
            },
        });
        l.then(() => message.success(allStrings.done, 2.5));
        return response.data;
    } catch (error) {
        console.log(error.response)
        if (error.response.data.errors[0].msg) {
            l.then(() => message.error(error.response.data.errors[0].msg, 2.5))
        } else {
            l.then(() => message.error(allStrings.error, 2.5))
        }
    }
};
export const updateCancelDealApi = async (id, data, token, isRTL, allStrings) => {
    let l = message.loading('Wait..', 2.5);
    try {
        const response = await axios.put(`${BASE_END_POINT}ads/${id}/cancelDeal`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${token}`,
                'Accept-Language': isRTL ? 'ar' : 'en'
            },
        });
        l.then(() => message.success(allStrings.done, 2.5));
        return response.data;
    } catch (error) {
        console.log(error.response)
        if (error.response.data.errors[0].msg) {
            l.then(() => message.error(error.response.data.errors[0].msg, 2.5))
        } else {
            l.then(() => message.error(allStrings.error, 2.5))
        }
    }
};
